import React from 'react';
import { Tooltip, Box, Stack, Typography } from '@mui/material';
import { formatIsoDate } from 'utils/common-util';
import { ReactComponent as CalendarGreyIcon } from '../../assets/icon-calendar-grey.svg';
import { colorsDark} from 'assets/theme/colorUtil';

type TooltipItem = {
	label: string;
	value: string;
};

export type DateInfoTooltipProps = {
	titleValues?: TooltipItem[];
	dateValues?: TooltipItem[];
	children: JSX.Element;
};

const DateInfoTooltip: React.FC<DateInfoTooltipProps> = ({ titleValues, dateValues, children }) => {
	return (
		<Tooltip
			arrow
			componentsProps={{
				tooltip: {
					sx: {
						bgcolor: `${colorsDark.backgroundLight.primary} !important`,
						color: colorsDark.textLight.dark,
						boxShadow: '0px 4px 12px rgba(0,0,0,0.08)',
						'& .MuiTooltip-arrow': { color: `${colorsDark.backgroundLight.primary} !important` }
					}
				}
			}}
			title={
				<Stack spacing={1} sx={{ color: 'inherit' }}>
					{titleValues?.map((item, index) => (
						<Stack key={`${item.label}-${index}`}>
							<Typography variant="subtitle2" color={colorsDark.textLight.dark} fontWeight="bold">
								{item.label}
							</Typography>
							<Typography variant="subtitle1" sx={{ color: colorsDark.textLight.dark }}>{item.value}</Typography>
						</Stack>
					))}
					<Box display="flex" gap={1}>
						{dateValues?.map((item, index) => (
							<Stack key={`${item.label}-${index}`}>
								<Typography variant="subtitle2" color={colorsDark.textLight.dark} fontWeight="bold">
									{item.label}
								</Typography>
								<Typography variant="subtitle1" color={colorsDark.textLight.dark}>
									{item.value && item.value !== 'NA' ? (
										<Box display="inline-flex" alignItems="center" gap={0.5}>
											{formatIsoDate(item.value)}{' '}
											<Box component="span">
												<CalendarGreyIcon />
											</Box>
										</Box>
									) : (
										'NA'
									)}
								</Typography>
							</Stack>
						))}
					</Box>
				</Stack>
			}
		>
			{children}
		</Tooltip>
	);
};

export default DateInfoTooltip;
